import React from 'react';
import { Link } from 'react-router-dom';
import BackgroundImage from '../../BackgroundImage';
import Img from '../../Img';
import Description from '../../text/Description';
import { Utr, UtrLabel } from '../../text';
import { isPickleBallSportTypeEvent } from '../../../utils/events';
import { getPickleBallRating } from '../../../utils';
import { gameTypes, ratingTypes } from '../../../utils/constants';

import styles from './teamStandingsCardV3.scss';

const TeamPlayerV2 = (props) => {
    const {
        player,
        index,
        userLoggedIn,
        showRatingNotLoggedIn,
        hideRatings,
        utrType,
        showDecimals,
        force = {},
        sportTypeId,
        divMedal,
        className = '',
        'data-testid': dataTestId,
    } = props;

    const {
        nationality,
        firstName,
        lastName,
        gender,
        descriptionLong,
        descriptionShort,
        location,
        ratingStatusDoubles,
        playerProfileImages,
    } = player;

    const isPickleBallSportType = isPickleBallSportTypeEvent(sportTypeId);
    const playerPkbRating = getPickleBallRating(player, gameTypes.DOUBLES);
    const nationalFlag = nationality ? `/img/flags/${nationality.toLowerCase()}.svg` : '';
    let description = '';
    if (descriptionLong) {
        description = [descriptionLong];
    } else {
        description = location?.display ? [location.display] : [];
    }
    const descriptionItems = [
        ...(gender ? [gender.charAt(0)] : []),
        ...(description),
    ];
    let descriptionMobile = '';
    if (descriptionShort) {
        descriptionMobile = [descriptionShort];
    } else {
        descriptionMobile = location?.display ? [location.display] : [];
    }
    const descriptionItemsMobile = [
        ...(gender ? [gender.charAt(0)] : []),
        ...(descriptionMobile),
    ];

    if (force.cardView) {
        return (
            <Link to={`/profiles/${player.id || player.playerId}`} target="_blank" data-testid={dataTestId && `${dataTestId}.card-link`}>
                <div className={`${className} d-flex flex-row ${index === 0 ? 'pb8' : ''} ${index === 1 ? 'pt8' : ''}`}>
                    <div className="mr8">
                        <div className="avatar-container ml-auto">
                            <BackgroundImage
                                baseUrl={'/v1/player/'}
                                defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                images={playerProfileImages}
                                imageType={'icon'}
                                parentStylesClass={`avatar ${styles.avatar}`}
                            />
                            {nationality && (
                                <div className={`flag-container ${styles.flagContainer}`}>
                                    <Img
                                        className={`flag ${styles.flag}`}
                                        src={nationalFlag}
                                        alt={nationality}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="flex-1">
                        <div className={`${styles.details} show-ellipsis`}>
                            <div className={`${styles.name} show-ellipsis clickable`} data-testid={dataTestId && `${dataTestId}.mobile.name`}>
                                {firstName} {lastName}
                            </div>
                            <div className={`${styles.description} show-ellipsis`}>
                                {hideRatings ? (
                                    <Description desc={descriptionItemsMobile} data-testid={dataTestId && `${dataTestId}.mobile.place`} />
                                ) : (
                                    <>
                                        {(userLoggedIn || showRatingNotLoggedIn) && !isPickleBallSportType && (
                                            <div className={`${index === 0 ? 'mb16' : ''}`}>
                                                <span
                                                    className={`text-dark value ${utrType === 'sanctioned' && ratingStatusDoubles !== 'Rated' ? 'text-lighter' : ''}`}
                                                    title={utrType === 'sanctioned' ? ratingStatusDoubles : ''}
                                                    data-testid={dataTestId && `${dataTestId}.mobile.doubles-utr`}
                                                >
                                                    <Utr player={player} force={{ ratingType: 'doubles', utrType, verifiedIcon: true, showDecimals }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.mobile.doubles-utr`} />
                                                </span>
                                                <span className="title" data-testid={dataTestId && `${dataTestId}.mobile.doubles-label`}>
                                                    <UtrLabel player={player} force={{ ratingType: 'doubles', utrType, typeDots: true }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.mobile.doubles-label`} />
                                                </span>
                                            </div>
                                        )}
                                        {(userLoggedIn || showRatingNotLoggedIn) && isPickleBallSportType && (
                                            <div>
                                                <span
                                                    className={`text-dark value ${utrType === 'sanctioned' ? 'text-lighter' : ''}`}
                                                    data-testid={dataTestId && `${dataTestId}.mobile.pkb-rating`}
                                                >
                                                    {(() => {
                                                        const ratingText = playerPkbRating.value ? ` (${ratingTypes.pickleball})` : '';
                                                        return `${playerPkbRating.value}${ratingText}`;
                                                    })()}
                                                </span>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                            {!!divMedal && (
                                <div className={`${styles.medal} show-ellipsis`} data-testid={dataTestId && `${dataTestId}.mobile.division-medal`}>
                                    {!!divMedal.divisionMedal && <Img src={`/img/medals/${divMedal.divisionMedal}.svg`} height={'14px'} />}
                                    {divMedal.divisionName}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Link>
        );
    }

    return (
        <Link to={`/profiles/${player.id || player.playerId}`} target="_blank" data-testid={dataTestId && `${dataTestId}.card-link`}>
            <div className={`d-flex ${index === 0 ? 'mb16' : ''} w-100`}>
                <div className="avatar-wrapper">
                    <BackgroundImage
                        baseUrl={'/v1/player/'}
                        defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                        images={playerProfileImages}
                        imageType={'icon'}
                        parentStylesClass={'avatar d-inline-block'}
                    />
                    {nationalFlag && <Img className="flag" src={nationalFlag} alt={nationality} />}
                </div>
                <div className="name-and-place show-ellipsis">
                    <div className="name show-ellipsis text-dark pointer" data-testid={dataTestId && `${dataTestId}.desktop.name`}>{firstName} {lastName}</div>
                    <div className="place show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.place`}>
                        {divMedal ? (
                            <div className="place show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.division-medal`}>
                                {!!divMedal.divisionMedal && <Img src={`/img/medals/${divMedal.divisionMedal}.svg`} />}
                                {divMedal.divisionName}
                            </div>
                        ) : (
                            <Description desc={descriptionItems} data-testid={dataTestId && `${dataTestId}.desktop.place`} />
                        )}
                    </div>
                </div>
            </div>
        </Link>
    );
};

TeamPlayerV2.defaultProps = {
    'data-testid': null,
};

export default TeamPlayerV2;
